import { Pipe, PipeTransform } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { GrundstueckIcpListEntryVm } from '../../../icp/meine-grundstuecke-icp/meine-grundstuecke-icp-table/meine-grundstuecke-icp-table.component';
import { GrundstueckIcpListEntry } from '../../../core/gb-api';
import { KompaktGrundstueckPipe } from '../../kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { DecimalHochkommaPipe } from './decimalHochkomma.pipe';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'grundstueckFilter'
})
export class GrundstueckFilterPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private decimalHochkommaPipe: DecimalHochkommaPipe,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe
  ) {
    keysToTranslate<string>([]);
  }

  transform(items: GrundstueckIcpListEntryVm[], filterTerm = ''): any {
    if (filterTerm) {
      return items.filter((entry) => this.containsTerm(entry.model, filterTerm.toLowerCase()));
    }
    return items;
  }

  private containsTerm(entry: GrundstueckIcpListEntry, filterTerm: string): boolean {
    if (entry.egrid.value.toLowerCase().includes(filterTerm)) {
      return true;
    }
    let kompaktGrundstueck: string = this.kompaktGrundstueckPipe.transform(entry).toLowerCase();
    if (kompaktGrundstueck.includes(filterTerm)) {
      return true;
    }
    let grundstueckArt: string = this.getKompaktArt(entry);
    if (grundstueckArt.includes(filterTerm)) {
      return true;
    }
    let adressen: string[] = this.getKompaktAdressen(entry);
    if (adressen.includes(filterTerm)) {
      return true;
    }
    let kurzbeschreibung = this.getKurzbeschreibung(entry);
    if (kurzbeschreibung.includes(filterTerm)) {
      return true;
    }
    return false;
  }

  getKurzbeschreibung(entry: GrundstueckIcpListEntry) {
    const flurnamen = [entry.flurnamen].filter((val) => val).join(' ');
    const flaeche = entry.flaecheQuadratMeter ? this.decimalHochkommaPipe.transform(entry.flaecheQuadratMeter) + ' m²' : '';
    const sonderrecht = entry.sonderrechtText || '';
    return [flurnamen, flaeche, sonderrecht]
      .filter((val) => val)
      .join(', ')
      .toLowerCase();
  }

  getKompaktArt(entry: GrundstueckIcpListEntry) {
    if (entry.grundstueckArt === 'SDR' && entry.sdrArt) {
      return this.translate.instant(entry.grundstueckArt) + ' (' + this.translate.instant(entry.sdrArt) + ')';
    }
    if (entry.ligArt) {
      return this.translate.instant(entry.ligArt + '_lang');
    }
    return this.translate.instant(entry.grundstueckArt).toLowerCase();
  }

  getKompaktAdressen(entry: GrundstueckIcpListEntry): string[] {
    const entries = entry.gebaeudeAdressen;
    let adressen: string[] = [];
    for (let entry of entries) {
      let strasseHausnummer = [entry.strasse, entry.strasse2, entry.hausnummer].filter((val) => val).join(' ');
      let plzOrtschaft = [entry.plz, entry.plzZusatz, entry.ortschaft].filter((val) => val).join(' ');
      let adresse: string = [entry.gebaeudeBezeichnung, strasseHausnummer, plzOrtschaft].filter((val) => val).join(' ');
      adressen.push(adresse.toLowerCase());
    }
    return adressen;
  }
}
